<template>
    <paper class='bill'>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            searchId="cost11"
            pageID="cost"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn">
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <span class="mgl-10">
                    <el-button v-has="'07010001'" icon="el-icon-download" size="mini" :loading="isHeadExport" @click="exportFile"></el-button>
                    </span>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="taskDetails" :loading="isExportTask" v-has="'07010009'">导出任务明细</el-button>
                <el-upload class="upload" action :show-file-list="false" :before-upload="beforeUpload" :on-success="afterUpload" :http-request="submitUpload">
                    <el-button type="primary" :loading="isBatchImport" v-has="'07010010'">批量导入确认</el-button>
                </el-upload>
            </div>
        </m-pane>
    </paper>
</template>

<script>
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import { getTasks, getExportLists, getExport, getImportTemplate } from '../../../api/cost.js';
import { BMS_TASK_TYPE, BUSINESS_TYPE } from '../../../utils/configuration';
const TWENTY = '20';
const ONE_HUNDRED = '100';
const INSTALL_FIFTTEN = '15';
const NETWORK_DISTRIBUTION = '21';
export default {
    name: 'costIndex',
    components: { mPane, paper },
    data() {
        return {
            config,
            selectData: [],
            totalData: [],
            array: [],
            selected: [],
            taskCodeList: [],
            searchDataLists: {},
            dataObj: {},
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            currentPage: 1,
            pageTotal: 0,
            loading: false,
            isHeadExport: false,
            isExportTask: false,
            isBatchImport: false,
            feeTaskCodeNumber: '',
            tasktype: '',
            tasktypeNum: '',
            businessType: '',
            businessTypeList: ''
        };
    },
    mounted() {
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    methods: {
        taskDetails() {
            if (this.selected.length === 0) {
                return this.$message.warning('至少选择一条数据');
            } else if (this.selected.length > 31) {
                return this.$message.warning('一次最多只能导出31个任务');
            }
            this.feeTaskCodeNumber = this.taskCodeList.join();
            this.arrayBollen = this.selected.map(item => { return item.feeTaskType; }).every(item => {
                return item === BMS_TASK_TYPE.BILLING_DATA_TASK && BMS_TASK_TYPE.ESTIMATED_DATA_TASK;
            });
            for (let index = 0; index < this.selected.length; index++) {
                if (!this.arrayBollen && this.selected[index].feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK) {
                    this.$message.warning('不同任务类型需要分开导出');
                    return false;
                } else {
                // 手工预估任务不区分业务类型，计费任务需要区分业务类型
                    if (this.selected[index].feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK && [...new Set(this.array)].length > 1) {
                        this.$message.warning('计费数据任务不同业务类型需要分开导出');
                        return false;
                    }
                }
                if (this.selected[index].feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK) {
                    if (this.businessTypeList === BUSINESS_TYPE.INSTALL) {
                        this.businessTypeList = INSTALL_FIFTTEN;
                    } else if (this.selected[index].stationCode) {
                        this.businessTypeList = NETWORK_DISTRIBUTION;
                    }
                }
                this.tasktypeNum = this.selected[index].feeTaskType === TWENTY ? ONE_HUNDRED : this.businessTypeList;
            }
            this.isExportTask = true;
            const params = { feeTaskCodes: this.feeTaskCodeNumber, businessType: this.tasktypeNum };
            getExport(params).then(res => {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = '任务明细.xlsx';
                a.click();
                document.body.removeChild(a);
            }).finally(() => { this.isExportTask = false; });
        },
        submitUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            this.isBatchImport = true;
            getImportTemplate(formData).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('导入成功');
                }
            }).finally(() => { this.isBatchImport = false; });
        },
        exportFile() {
            this.feeTaskCodeNumber = this.taskCodeList.join();
            if (this.selected.length === 0) {
                return this.$message.warning('至少选择一条数据');
            } else if (this.selected.length > 31) {
                return this.$message.warning('一次最多只能导出31个任务');
            }
            this.arrayBollen = this.selected.map(item => { return item.feeTaskType; }).every(item => {
                return item === BMS_TASK_TYPE.BILLING_DATA_TASK && BMS_TASK_TYPE.ESTIMATED_DATA_TASK;
            });
            // 1 是运配  2 装卸  3 仓储  4 快递  5  手工预估 6安装 7网点配送
            for (let index = 0; index < this.selected.length; index++) {
                if ((this.selected[index].businessType === '3' || this.selected[index].businessType === '4' ||
                this.selected[index].businessType === '10') && (this.selected[index].feeTaskType === '10')) {
                    this.tasktype = '1';
                } else if ((this.selected[index].feeTaskType === '10') && (this.selected[index].businessType === '2')) {
                    this.tasktype = '2';
                } else if ((this.selected[index].feeTaskType === '10') && (this.selected[index].businessType === '1')) {
                    this.tasktype = '3';
                } else if ((this.selected[index].feeTaskType === '10') && (this.selected[index].businessType === '5')) {
                    this.tasktype = '4';
                } else if (this.selected[index].feeTaskType === '20') {
                    this.tasktype = '5';
                }
                if (this.selected[index].feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK) {
                    if (this.selected[index].businessType === BUSINESS_TYPE.INSTALL) {
                        this.tasktype = '6';
                    } else if (this.selected[index].stationCode) {
                        this.tasktype = '7';
                    }
                }
                if (!this.arrayBollen && this.selected[index].feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK) {
                    this.$message.warning('不同任务类型需要分开导出');
                    return false;
                } else {
                    // 手工预估任务不区分业务类型，计费任务需要区分业务类型
                    if (this.selected[index].feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK && [...new Set(this.array)].length > 1) {
                        this.$message.warning('计费数据任务不同业务类型需要分开导出');
                        return false;
                    }
                }
            }
            this.isHeadExport = true;
            const params = { pmCodes: this.feeTaskCodeNumber, tasktype: this.tasktype };
            getExportLists(params).then(res => {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = objectUrl;
                a.download = '费用明细.xlsx';
                a.click();
                document.body.removeChild(a);
            }).finally(() => { this.isHeadExport = false; });
        },
        getTasks() {
            this.$refs.tablePage.$refs.searchList.changeLoading(true);
            this.loading = true;
            const params = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, ...this.searchDataLists };
            this.businessTypeList = params.businessType;
            this.currentPage = this.searchObj.pageNo;
            getTasks(params).then(res => {
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
                this.loading = false;
                if (res.code === '0' && res) {
                    this.totalData = res.data.list || [];
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        beforeUpload(file) {
            const fileNameArr = file.name.split('.');
            const fileType = fileNameArr[fileNameArr.length - 1];
            const Excel = fileType === 'xls' || fileType === 'xlsx';
            if (!Excel) {
                this.$message.error('上传失败，文件格式只能为 xlsx 或 xls');
            }
            return Excel;
        },
        afterUpload(response) {
            if (response && response.code === '0') {
                this.$message.success('导入成功');
            } else {
                this.$message.error('导入失败');
            }
        },
        searchChange(data) {
            this.searchObj.pageNo = 1;
            data = this.formattingData(data);
            this.searchDataLists = data;
            this.getTasks();
        },
        pageChange(data) {
            this.searchObj.pageNo = data;
            this.getTasks();
        },
        sizeChange(data) {
            this.currentPage = 1;
            this.searchObj.pageNo = 1;
            this.searchObj.pageSize = data;
            this.getTasks();
        },
        formattingData(data) {
            const tempData = { ...data };
            return tempData;
        },
        ifEsstStattionCode (row) {
            if (row && row.stationCode) {
                this.$router.push({ query: { feeTaskCode: row.feeTaskCode, jobid: row.jobId }, path: `/bms/networkDistribution` });
            } else {
                this.$router.push({ query: { feeTaskCode: row.feeTaskCode, jobid: row.jobId }, path: `/bms/distribution` });
            }
        },
        rowDBclick(row) {
            if (row.feeTaskCode) {
                switch (row.businessType) {
                case BUSINESS_TYPE.LOADING_AND_UNLOADING: this.$router.push({ query: { feeTaskCode: row.feeTaskCode, jobid: row.jobId }, path: `/bms/loadAndUnload` });
                    break;
                case BUSINESS_TYPE.EXPRESS_DELIVERY: this.$router.push({ query: { feeTaskCode: row.feeTaskCode, jobid: row.jobId }, path: `/bms/deliver` });
                    break;
                case BUSINESS_TYPE.TRANSPORT:
                case BUSINESS_TYPE.DELIVERY:
                case BUSINESS_TYPE.HOME_DELIVERY:
                    this.ifEsstStattionCode(row);
                    break;
                case BUSINESS_TYPE.INSTALL: this.$router.push({ query: { feeTaskCode: row.feeTaskCode, jobid: row.jobId }, path: `/bms/install` });
                    break;
                default : this.$router.push({ query: { feeTaskCode: row.feeTaskCode, jobid: row.jobId }, path: `/bms/warehouse` });
                };
                switch (row.feeTaskType) {
                case BMS_TASK_TYPE.ESTIMATED_DATA_TASK: this.$router.push({ query: { feeTaskCode: row.feeTaskCode, jobid: row.jobId }, path: `/bms/manualEstimate` });
                    break;
                }
            } else {
                return this.$message.warning('没有对应的任务编号，不允许查询数据');
            }
        },
        selectChange(data) {
            this.array = [];
            this.taskCodeList = [];
            data.forEach(item => {
                this.array.push(item.businessType);
                this.taskCodeList.push(item.feeTaskCode);
                this.feeTaskCode = item.feeTaskCode;
                this.businessTypeList = item.businessType;
            });
            this.selected = [].concat(data);
        }
    },
    watch: {
        '$route': 'getTasks'
    }
};
</script>

<style lang="less">
.bill {
    .upload {
        display: inline-block;
        margin-left: 10px;
    }
}
</style>
